export type SeasonUndertone = 'spring' | 'summer' | 'autumn' | 'winter';

export const legacyUndertoneForApi = (
  undertone: SeasonUndertone
): 'warm' | 'cool' | 'neutral' => {
  if (undertone === 'spring') return 'warm';
  if (undertone === 'autumn') return 'neutral';
  return 'cool';
};

export const parseUndertoneFromStorage = (
  raw: string | null | undefined
): SeasonUndertone => {
  const value = (raw || '').toLowerCase().trim();
  if (
    value === 'spring' ||
    value === 'summer' ||
    value === 'autumn' ||
    value === 'winter'
  ) {
    return value;
  }
  if (value === 'warm') return 'spring';
  if (value === 'cool') return 'summer';
  if (value === 'neutral') return 'autumn';
  return 'spring';
};

export const seasonFromSkin = (
  hue: number,
  saturation: number,
  value: number
): SeasonUndertone => {
  const warmHue = hue >= 15 && hue <= 45;
  const coolHue =
    (hue >= 0 && hue < 15) ||
    (hue > 45 && hue <= 60) ||
    (hue >= 330 && hue <= 360);

  if (warmHue) {
    // Deep/dark warm skin → autumn; medium warm → spring only when bright enough
    if (value < 0.45) return 'autumn';
    return saturation >= 0.38 && value >= 0.55 ? 'spring' : 'autumn';
  }
  if (coolHue) {
    // Deep cool → winter; lighter cool → summer
    if (value < 0.45 || saturation >= 0.38) return 'winter';
    return 'summer';
  }
  // Neutral hue: brightness drives spring vs autumn
  return value >= 0.6 && saturation >= 0.25 ? 'spring' : 'autumn';
};
